<template>
  <VueFinalModal
    v-model="showModal"
    :esc-to-close="true"
    class="modal-container"
    content-class="modal-content"
  >
    <div class="modal__content">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p style="text-align: center; font-weight: bold; margin: 0px">
            Datos del usuario
          </p>

          <p class="p_text">
            <span class="textLabel">Usuario: </span>{{ displayName }}
          </p>

          <p class="p_text"><span class="textLabel">DNI: </span>{{ dni }}</p>

          <p class="p_text">
            <span class="textLabel">Contacto: </span>{{ contact }}
          </p>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <hr class="horizontal dark" />
          <p style="text-align: center; font-weight: bold; margin: 0px">
            Datos bancarios
          </p>

          <p class="p_text"><span class="textLabel">Banco: </span>{{ bank }}</p>

          <p class="p_text">
            <span class="textLabel">Nro. cuenta: </span>{{ numberaccount }}
          </p>

          <p class="p_text"><span class="textLabel">Tipo: </span>{{ type }}</p>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <hr class="horizontal dark" />
          <p style="text-align: center; font-weight: bold; margin: 0px">
            Datos de transacción
          </p>

          <p class="p_text"><span class="textLabel">Fecha: </span>{{ date }}</p>

          <p class="p_text">
            <span class="textLabel">Referencia: </span>{{ ref }}
          </p>

          <!-- <p class="p_text">
            <span class="textLabel">Monto: </span>$ {{ amount }}
          </p> -->

          <p class="p_text">
            <span class="textLabel">Monto a transferir: </span>$
            {{ transferAmount }}
          </p>
        </div>
      </div>
    </div>
  </VueFinalModal>
  <div class="card" style="margin-bottom: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i> Solicitudes
            de retiros de dinero
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="notAllow" class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <img style="width: 100px" src="/img/caution.svg" />

          <p style="margin-top: 10px; font-size: 14px">
            Tu rol no te permite utilizar la siguiente funcionalidad.
          </p>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="paymentRequests"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha/Hora</th>
            <th data-priority="1">Usuario</th>
            <th>DNI</th>
            <th>Contacto</th>
            <th>Monto a Retirar</th>
            <th data-priority="2">Acción</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    VueFinalModal,
  },
  props: ["userId", "tokenAuth", "idAdmin"],
  data() {
    let role = localStorage.getItem("session");

    return {
      loading: true,
      showModal: false,
      paymentRequests: [],
      notAllow: false,
      displayName: "",
      dni: "",
      contact: "",
      bank: "",
      numberaccount: "",
      type: "",
      date: "",
      ref: "",
      amount: "",
      transferAmount: "",
      role: role,
      actionInProgress: false,
      columns: [
        { data: "dateFormatted" },
        { data: "user.displayName" },
        { data: "user.dni" },
        { data: "user.phone" },
        {
          data: null,
          render: function (data, type, row, meta) {
            return `$${data.balance.toFixed(2)}`;
          },
        },
        {
          data: null,
          render: function (data, type, row, meta) {
            return `
          <div class="dropdown">
<button class="btn btn-primary btn-sm dropdown-toggle " type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
  <i class="fas fa-ellipsis-v" style="margin-right:10px"></i>
</button>
<ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
  <li><button data-id="${data.id}" data-displayname="${data.user.displayName}" data-bank="${data.bank.bank}" data-userid="${data.userId}"  data-amount="${data.balance.toFixed(2)}" data-tipo="Aprobar" class="aprobar dropdown-item" type="button"><i class="fas fa-check-circle" style="margin-right:10px"></i>Aprobar retiro</button></li>
  <li><button data-id="${data.id}" data-displayname="${data.user.displayName}" data-bank="${data.bank.bank}" data-userid="${data.userId}"  data-amount="${data.balance.toFixed(2)}" data-tipo="Rechazar" class="dropdown-item rechazar" type="button"><i class="fas fa-times-circle" style="margin-right:10px"></i>Rechazar retiro</button></li>
  <li><button  data-transferamount="${data.balance.toFixed(2)}" data-date="${data.dateFormatted}" data-amount="${data.balance}" data-ref="${data.ref}" data-type="${data.bank.type}" data-displayname="${data.bank.bankUserName ?? data.user.displayName}" data-bank="${data.bank.bank}" data-numberaccount="${data.bank.numberAccount}" data-contact="${data.bank.bankUserEmail ?? data.user.email}" data-dni="${data.bank.bankUserDni ?? data.user.dni}" class="dropdown-item verDatos" type="button"><i class="fas fa-eye" style="margin-right:10px"></i>Ver datos</button></li>
</ul>
</div>


          `;
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Ingrese algún dato",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getListado();
    this.bindTableActions();
  },
  beforeUnmount() {
    this.unbindTableActions();
  },
  methods: {
    unbindTableActions() {
      $(document).off("click.listadoRetiros");
    },
    bindTableActions() {
      // Namespaced listeners: bind once; never re-bind on refresh (avoids duplicates)
      this.unbindTableActions();

      $(document).on("click.listadoRetiros", ".aprobar", (evt) => {
        const $btn = $(evt.target).closest(".aprobar");
        if (!$btn.length) return;

        this.aprobar(
          $btn.data("displayname"),
          $btn.data("bank"),
          $btn.data("amount"),
          $btn.data("id"),
          this.tokenAuth,
          "paid",
          this.role
        );
      });

      $(document).on("click.listadoRetiros", ".rechazar", (evt) => {
        const $btn = $(evt.target).closest(".rechazar");
        if (!$btn.length) return;

        this.rechazar(
          $btn.data("displayname"),
          $btn.data("bank"),
          $btn.data("amount"),
          $btn.data("id"),
          this.tokenAuth,
          "rejected",
          this.role
        );
      });

      $(document).on("click.listadoRetiros", ".verDatos", (evt) => {
        const $btn = $(evt.target).closest(".verDatos");
        if (!$btn.length) return;

        this.showDatos(
          $btn.data("displayname"),
          $btn.data("dni"),
          $btn.data("contact"),
          $btn.data("bank"),
          $btn.data("numberaccount"),
          $btn.data("type"),
          $btn.data("date"),
          $btn.data("ref"),
          $btn.data("amount"),
          $btn.data("transferamount")
        );
      });
    },
    rechazar(displayName, bank, amount, idPayment, tokenAuth, status, session) {
      if (this.actionInProgress || !idPayment) return;
      this.actionInProgress = true;

      let title = "";
      let textButton = "";
      let html = "";
      html =
        '<div style="margin-top:10px" class="table-responsive"><table class="table table-bordered" style="text-align: center;"><tbody><tr><td class="background_table">Usuario:</td><td class="td_table">' +
        displayName +
        '</td></tr><tr><td class="background_table">Banco:</td><td class="td_table">' +
        bank +
        '</td></tr><tr> <td class="background_table">Monto:</td><td class="td_table">$' +
        amount +
        ' USD</td></tr></tbody></table><p style="text-align: left;margin-bottom: 0px;margin-top: 15px;">Ingrese el motivo del rechazo de la solicitud:</p>';

      title = "¿Estas seguro que deseas rechazar esta solicitud?";
      textButton = "Rechazar";

      this.$swal({
        title: title,
        html: html,
        icon: "warning",
        showCancelButton: true,
        input: "text",
        inputPlaceholder: "Motivo del rechazo de solicitud",
        inputAttributes: {
          autocapitalize: "off",
        },
        confirmButtonText: textButton,
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: (motivo) => {
          if (motivo != "") {
            return this.$https
              .post("/transactions/manageWithdrawalRequest", {
                tokenAuth,
                idPayment,
                status,
                session,
                message: motivo,
              })
              .then((response) => response.data)
              .catch((error) => {
                this.$swal.showValidationMessage(error);
              });
          } else {
            this.$swal.showValidationMessage(
              "El motivo del rechazo es obligatorio"
            );
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      })
        .then((result) => {
          this.$swal.close();

          if (result.isConfirmed) {
            if (result.value.code == 204) {
              this.refresh();

              this.$toast.success(result.value.message, {
                position: "top-right",
                max: 10,
              });
            } else {
              this.$toast.error(result.value.message, {
                position: "top-right",
                max: 10,
              });
              if (result.value.code == 401) {
                localStorage.removeItem("userData");
                this.$store.state.user = "";

                // Redirect to login page
                this.$router.push({ name: "Signin" });
              } else {
                if (result.value.code == 402) {
                  this.refresh();
                }
              }
            }
          }
        })
        .finally(() => {
          this.actionInProgress = false;
        });
    },

    aprobar(displayName, bank, amount, idPayment, tokenAuth, status, session) {
      if (this.actionInProgress || !idPayment) return;
      this.actionInProgress = true;

      let title = "";
      let textButton = "";
      let html = "";
      html =
        '<div style="margin-top:10px" class="table-responsive"><table class="table table-bordered" style="text-align: center;"><tbody><tr><td class="background_table">Usuario:</td><td class="td_table">' +
        displayName +
        '</td></tr><tr><td class="background_table">Banco:</td><td class="td_table">' +
        bank +
        '</td></tr><tr> <td class="background_table">Monto:</td><td class="td_table">$' +
        amount +
        " USD</td></tr></tbody></table>";

      title = "¿Estas seguro que deseas aprobar esta solicitud?";
      textButton = "Aprobar";

      this.$swal({
        title: title,
        html: html,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: textButton,
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.$https
            .post("/transactions/manageWithdrawalRequest", {
              tokenAuth,
              idPayment,
              status,
              session,
            })
            .then((response) => response.data)
            .catch((error) => {
              this.$swal.showValidationMessage(error);
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      })
        .then((result) => {
          this.$swal.close();

          if (result.isConfirmed) {
            if (result.value.code == 200) {
              this.refresh();

              this.$toast.success(result.value.message, {
                position: "top-right",
                max: 10,
              });
            } else {
              this.$toast.error(result.value.message, {
                position: "top-right",
                max: 10,
              });
              if (result.data.code == 401) {
                localStorage.removeItem("userData");
                this.$store.state.user = "";

                // Redirect to login page
                this.$router.push({ name: "Signin" });
              } else {
                if (result.data.code == 402) {
                  this.refresh();
                }
              }
            }
          }
        })
        .finally(() => {
          this.actionInProgress = false;
        });
    },

    showDatos(
      displayName,
      dni,
      contact,
      bank,
      numberaccount,
      type,
      date,
      ref,
      amount,
      transferAmount
    ) {
      this.showModal = true;

      this.displayName = displayName;
      this.dni = dni;
      this.contact = contact;
      this.bank = bank;
      this.numberaccount = numberaccount;
      this.type = type;
      this.date = date;
      this.ref = ref;
      this.amount = amount;
      this.transferAmount = transferAmount;
    },

    refresh() {
      this.getListado();
    },

    getListado() {
      this.loading = true;
      const session = localStorage.getItem("session");
      this.$https
        .post("/balance/loadPaymentRequest/", {
          tokenAuth: this.tokenAuth,
          session: session,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.loading = false;
            this.paymentRequests = response.data.paymentRequestList;
          } else {
            this.loading = false;
            this.paymentRequests = [];
          }
        })
        .catch((error) => {
          if (error.data.code == 401) {
            localStorage.removeItem("userData");
            this.$store.state.user = "";

            // Redirect to login page
            this.$router.push({ name: "Signin" });
          } else {
            if (error.data.code == 403) {
              this.$router.push({ name: "Dashboard" });
            } else {
              if (error.data.code == 404) {
                this.loading = false;
                this.notAllow = false;
              } else {
                if (error.data.code === 501) {
                  this.loading = false;

                  this.notAllow = true;
                } else {
                  this.getListado();
                }
              }
            }
          }
          this.getListado();
        });
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";
</style>
